var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"pointer mr-4",attrs:{"src":"/assets/img/icons/edit.png","alt":"update item","width":"25px"},on:{"click":_vm.openEditItem}}),_c('CreateItemsModal',{attrs:{"id":`item${_vm.item.reference}`,"closeModal":_vm.closeModal,"item":_vm.item,"refetch":_vm.refetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }